import { Api } from '../api';
import { auth } from '../endpoints';
import type { CodeRequest, LoginRequest, LoginResponse, RecoveryRequest, RefreshRequest, RegisterRequestStore } from './models';

export class AuthApi extends Api {
  static login = (request: LoginRequest, signal?: AbortSignal) =>
    this.post<LoginRequest, LoginResponse>({ url: auth.login(), data: request, signal: signal });

  static verifyCode = (request: CodeRequest, signal?: AbortSignal) =>
    this.post<CodeRequest, LoginResponse>({ url: auth.verifyCode(), data: request, signal: signal });

  static refresh = (request: RefreshRequest, signal?: AbortSignal) =>
    this.post<RefreshRequest, LoginResponse>({ url: auth.refresh(), data: request, signal: signal });

  static register = (request: RegisterRequestStore, signal?: AbortSignal) =>
    this.post<RegisterRequestStore, string>({ url: auth.register(), data: request, signal: signal });

  static recoveryPassword = (request: RecoveryRequest, signal?: AbortSignal) =>
    this.post<RecoveryRequest, string>({ url: auth.recoverPassword(), data: request, signal: signal });
}
